import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterBy',
  standalone: false,
})
export class FilterByPipe implements PipeTransform {
  transform<T>(array: T[], property: keyof T, value: any): T[] {
    if (!array || !property) {
      return array;
    }

    return array.filter((item) => item[property] === value);
  }
}
